import React, { useState } from 'react';
import { Reveal } from '../ui/Reveal';

const LeadForm = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <section id="contact" className="py-24 bg-charcoal-950 border-t border-white/5">
      <div className="container mx-auto px-6 md:px-12 max-w-4xl">
        <Reveal>
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-white mb-4">Request Your Appraisal Quote</h2>
            <p className="text-gray-400">Fill out the details below and our MAI-designated experts will respond promptly.</p>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="bg-charcoal-900 border border-white/10 p-8 md:p-12">
            {submitted ? (
              <div className="text-center py-12">
                <h3 className="text-2xl font-bold text-gold-500 mb-2">Request Received.</h3>
                <p className="text-gray-300">We will be in touch shortly with your custom quote.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <input required type="text" className="w-full px-4 py-3 bg-charcoal-850 border border-white/10 text-white focus:border-gold-500 outline-none transition-all placeholder-gray-600" placeholder="First Name *" />
                  </div>
                  <div>
                    <input required type="text" className="w-full px-4 py-3 bg-charcoal-850 border border-white/10 text-white focus:border-gold-500 outline-none transition-all placeholder-gray-600" placeholder="Last Name *" />
                  </div>
                </div>
                
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <input required type="email" className="w-full px-4 py-3 bg-charcoal-850 border border-white/10 text-white focus:border-gold-500 outline-none transition-all placeholder-gray-600" placeholder="Email Address *" />
                  </div>
                  <div>
                    <input type="tel" className="w-full px-4 py-3 bg-charcoal-850 border border-white/10 text-white focus:border-gold-500 outline-none transition-all placeholder-gray-600" placeholder="Phone Number" />
                  </div>
                </div>

                <div>
                  <select required className="w-full px-4 py-3 bg-charcoal-850 border border-white/10 text-gray-300 focus:border-gold-500 outline-none transition-all appearance-none cursor-pointer">
                    <option value="" disabled selected>Select Property Type *</option>
                    <option value="office">Office Building</option>
                    <option value="retail">Retail Center</option>
                    <option value="multifamily">Multifamily</option>
                    <option value="industrial">Industrial</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div>
                  <textarea rows="4" className="w-full px-4 py-3 bg-charcoal-850 border border-white/10 text-white focus:border-gold-500 outline-none transition-all placeholder-gray-600" placeholder="Purpose of Appraisal (Optional)"></textarea>
                </div>

                <div className="text-center pt-4">
                  <button type="submit" className="btn-gold w-full md:w-auto">
                    GET MY VALUATION QUOTE
                  </button>
                </div>
              </form>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default LeadForm;